<template>
   <div id="bonos">
      <div v-if="loading" id="loading" class="loading_full">Loading&#8230;</div>
      <div class="card">
         <div class="card-body">
            <h4 class="fw-bolder mb-4">Bonos</h4>
            <div>
               <div>
                  <div v-if="bonos.length != 0" class="table-responsive mt-3">
                     <table
                        class="table table-hover table-bordered table-condensed my_table_1"
                     >
                        <thead class="table-light">
                           <tr>
                              <th style="width: 20%">Fecha de registro</th>
                              <th style="width: 10%" class="text-center">
                                 Id Reserva
                              </th>
                              <th style="width: 12%">Código Bono</th>
                              <th style="width: 15%">Total</th>
                              <th style="width: 15%">Saldo</th>
                              <th style="width: 10%" class="text-center">
                                 Estado
                              </th>
                              <th class="text-center" style="width: 10%">
                                 Opciones
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr
                              v-for="(bono, index) in bonos"
                              v-bind:key="index"
                           >
                              <td>
                                 <strong>{{ bono.fecha_reg }}</strong>
                              </td>
                              <td class="text-center">
                                 <router-link
                                    :to="'/reserva/' + bono.id_reserva"
                                 >
                                    <strong>{{ bono.id_reserva }}</strong>
                                 </router-link>
                              </td>
                              <td class="text-primary">
                                 <strong>{{ bono.cod_bono }}</strong>
                              </td>
                              <td class="text-end">
                                 <strong>{{ bono.valor | currency }}</strong>
                              </td>
                              <td class="text-end text-success">
                                 <strong>{{ bono.saldo | currency }}</strong>
                              </td>
                              <td class="text-center">
                                 <label
                                    v-if="bono.estado == 0"
                                    class="text-danger"
                                    >Anulado</label
                                 >
                                 <label
                                    v-if="bono.estado == 1"
                                    class="text-success"
                                    >Activo</label
                                 >
                              </td>
                              <td class="text-end">
                                 <button
                                    v-if="bono.pagos.length != 0"
                                    v-on:click="bonoSel = bono"
                                    data-bs-toggle="modal"
                                    data-bs-target="#detallePagosBono"
                                    class="btn btn-info btn-sm btn-rounded"
                                 >
                                    <i class="fa fa-list"></i>
                                 </button>
                                 <button
                                    v-on:click="bonoSel = bono"
                                    data-bs-toggle="modal"
                                    data-bs-target="#eliminarBono"
                                    class="btn btn-danger btn-sm btn-rounded"
                                    :disabled="bono.estado == 0"
                                 >
                                    <i class="fa fa-trash"></i>
                                 </button>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div v-else>
                     <div class="text-muted">
                        <i class="fa-solid fa-circle-info"></i> No se han
                        agregado bonos.
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- Pagos bono -->
      <div class="modal fade" id="detallePagosBono">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-success">
                  <h5 class="modal-title fw-bolder">Pagos con bono</h5>
                  <button
                     id="close_modal_pagos_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="bonoSel != null" class="modal-body">
                  <table class="table table-hover table-condensed my_table_2">
                     <thead>
                        <tr>
                           <th>Fecha de pago</th>
                           <th>Reserva</th>
                           <th class="text-end">Valor</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr
                           v-for="(pago, index_pago) in bonoSel.pagos"
                           v-bind:key="index_pago"
                        >
                           <td class="fw-bolder text-primary">
                              {{ pago.fecha_pago }}
                           </td>
                           <td class="fw-bolder text-primary">
                              <router-link
                                 :to="'/reserva/' + pago.id_reserva"
                                 target="_blank"
                              >
                                 {{ pago.cod_reserva }}
                              </router-link>
                           </td>
                           <td class="text-end">
                              {{ pago.valor | currency }}
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>

      <!-- Eliminar bono -->
      <div class="modal fade" id="eliminarBono">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header text-danger">
                  <h5 class="modal-title fw-bolder">Anular bono</h5>
                  <button
                     id="close_modal_eliminar_bono"
                     type="button"
                     class="close"
                     data-bs-dismiss="modal"
                  >
                     <span>&times;</span>
                  </button>
               </div>
               <div v-if="bonoSel != null" class="modal-body">
                  <div class="text-danger">
                     <div class="mb-3">
                        <i class="fa fa-question-circle"></i> ¿Desea anular este
                        bono? El saldo disponible no podrá ser utilizado.
                     </div>
                     <div>
                        <ul>
                           <li>
                              Fecha de registro:
                              <strong>{{ bonoSel.fecha_reg }}</strong>
                           </li>
                           <li>
                              Valor:
                              <strong>{{ bonoSel.valor | currency }}</strong>
                           </li>
                           <li>
                              Saldo:
                              <strong>{{ bonoSel.saldo | currency }}</strong>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="text-end">
                     <button
                        v-on:click="deleteBono"
                        class="btn btn-danger rounded-pill btn-sm"
                     >
                        <i class="fa fa-trash"></i> Sí
                     </button>
                     <button
                        data-bs-dismiss="modal"
                        class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                     >
                        No
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
   name: "Bonos",
   metaInfo: {
      title: "Bonos - Backoffice",
   },
   data() {
      return {
         loading: true,
         page: 1,
         search: null,
         bonoSel: null,
         bonos: [],
      };
   },
   props: {
      session: Object,
   },
   created: function () {
      this.getBonos();
   },
   methods: {
      getBonos: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               page: this.page,
               search: this.search,
            },
         };
         axios
            .get(vm.$base_url + "reservas/bonos", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.bonos = response.data.data.bonos;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Bonos",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Bonos",
                  text: error,
               });
               vm.loading = false;
            });
      },
      deleteBono: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": this.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            idBono: this.bonoSel.id_bono,
         };
         axios
            .post(this.$base_url + "reservas/deleteBono", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Eliminar bono",
                     text: response.data.message,
                  });
                  document.getElementById("close_modal_eliminar_bono").click();
                  vm.bonoSel = null;
                  vm.getBonos();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            })
            .finally();
      },
   },
};
</script>
